import React from "react";
import { useNavigate } from "react-router-dom";
import AuditAssurancecomponents from "./AuditAssurancecomponents";
import CallToAction from "./CallToAction";

const AuditAssuranceInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section audit-fin">
                <h2 className="other-pages-title">Audit & Assurance Services</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/audit-assurance-services-india")} style={{ cursor: "pointer" }}>Audit & Assurance Services</span>
                </p>
            </div>
            <AuditAssurancecomponents />
            <CallToAction />
        </>
    );
};

export default AuditAssuranceInfo;
